<ami-dialog-message [setting]="message"></ami-dialog-message>

<ami-table
  [settings]="table.settings"
  (action)="onReciveAction($event)"
  [data]="table.data"
></ami-table>

<pg-products-of-provider-create
  *ngIf="open.create"
  (close)="onCloseCreate()"
></pg-products-of-provider-create>

<pg-products-of-provider-update
  [row]="itemToUpdate"
  *ngIf="open.update"
  (close)="onCloseUpdate()"
>
</pg-products-of-provider-update>
